export const VERTICAL_TABS = {
    LAYOUT: 'layout',
    THEME: 'theme',
    CSS: 'css'
} as const;